import { useQuery } from "react-query";
import { getOfficeByOfficeId } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetOfficeByOfficeId = (officeId) => {
  return useQuery(
    ["GetOfficeByOfficeId ", officeId],
    () => getOfficeByOfficeId(officeId),
    { refetchOnWindowFocus: false }
  );
};
